/**
 * Clip API
 */
import { defaults, get, patch, post, delete as _delete } from "axios";

defaults.headers.common['Accept'] = 'application/json';
defaults.headers.post['Content-Type'] = 'application/json';


export default {
    /**
     * Get Clipd articles List
     */
    getClipList(token) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}clip`,
                config = {
                    headers: {
                        auth_token: token,
                    }
                };

            get(url, config)
                .then(res => {
                    resolve(res)
                })
                .catch(error => {
                    reject(error)
                })
        })
    },


    /**
     * Remove Bookmark of a certain article
     * @param {arrayList} params 
     */
    removeFromFavorite(params, token) {
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}clip`,
                config = {
                    data: params,
                    headers: {
                        auth_token: token,
                    }
                };

            _delete(url, config)
                .then(response => {
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
        })
    },

    /**
     * Add To Favorite
     */
    addArticleToFavorite(param, token){
        return new Promise((resolve, reject) => {
            let url = `${process.env.API_BASE_URL}clip`,
                config = {
                    headers: {
                        auth_token: token,
                    }
                },
                params= {
                    article_id: param.articleId,
                    language_id: param.lang_id
                };

            post(url, params, config)
                .then(response => {
                    resolve(response);
                }).catch(error => {
                    reject(error);
                });
        }) 
    },


    
    increaseArticleFavoriteCount(args){
    
            return new Promise((resolve, reject) => {
                const url = `${process.env.UNI_API}/api/com/favcounter/`;
    
                patch(url, {
                    token: process.env.UNIQUE_TOKEN,
                    lang_id: args.lang_id,
                    article_id: args.article_id,
                    count_type: 'inc',
                })
                    .then((response) => {
                        if (response.data.message == 'success!') {
                            resolve(response.data.message)
                        } else {
                            reject(response.data.message)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
    },
    
    decreaseArticleFavoriteCount (args) {
            return new Promise((resolve, reject) => {
                const url = `${process.env.UNI_API}/api/com/favcounter/`;

                patch(url, {
                    token: process.env.UNIQUE_TOKEN,
                    lang_id: args.lang_id,
                    article_id: args.article_id,
                    count_type: 'dec',
                })
                    .then((response) => {
                        if (response.data.message == 'success!') {
                            resolve(response.data.message)
                        } else {
                            reject(response.data.message)
                        }
                    })
                    .catch((error) => {
                        reject(error)
                    })
            })
    }
    
}



// WEBPACK FOOTER //
// ./src/api/clip.js